function transfer_targets_Reducer(state = null, action) {
    switch (action.type) {
        case 'TRANSFER_TARGETS/SET':
            return action.targets;
        case 'TRANSFER_TARGETS/CLEAR':
            return null;
        default:
            return state;
    }
}

export default transfer_targets_Reducer;
